if (!customElements.get('free-shipping-bar')) {
  customElements.define(
    'free-shipping-bar',
    class extends HTMLElement {
      connectedCallback() {
        // data-threshold em CENTAVOS (ex.: 6990 = R$ 69,90)
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;

        // IDs que liberam frete grátis (troque pelos da outra loja)
        this.freeShippingProductIds = [
        ];

        this.requestId = 0;
        this.mount(0);
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.observer) this.observer.disconnect();
        if (this.onCartRefresh) document.removeEventListener('cart:refresh', this.onCartRefresh);
      }

      mount(attempt) {
        this.textEl = this.querySelector('#BCFreeShippingText') || this.querySelector('.free-shipping-notice__text');
        this.barEl = this.querySelector('#BCFreeShippingBar') || this.querySelector('.free-shipping-bar');

        if ((!this.textEl || !this.barEl) && attempt < 30) {
          requestAnimationFrame(() => this.mount(attempt + 1));
          return;
        }

        if (!this.textEl || !this.barEl) return;

        const total = parseInt(this.dataset.total, 10) || 0;
        this.update(total, []);

        this.refresh();
        this.bindEvents();
      }

      bindEvents() {
        const events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
        const sub = typeof subscribe !== 'undefined' ? subscribe : window.subscribe;

        if (sub && events && events.cartUpdate) {
          this.unsubscribe = sub(events.cartUpdate, () => this.refresh());
        }

        this.watchDom();

        this.onCartRefresh = () => this.refresh();
        document.addEventListener('cart:refresh', this.onCartRefresh);
      }

      watchDom() {
        const itemsEl = document.querySelector('#CartDrawer-CartItems');
        if (!itemsEl || !window.MutationObserver) return;

        let debounce = null;
        this.observer = new MutationObserver(() => {
          clearTimeout(debounce);
          debounce = setTimeout(() => this.refresh(), 120);
        });

        this.observer.observe(itemsEl, { childList: true, subtree: true });
      }

      refresh() {
        const id = ++this.requestId;

        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((response) => response.json())
          .then((cart) => {
            if (id !== this.requestId) return;
            this.dataset.total = cart.total_price;
            this.update(cart.total_price, cart.items);
          })
          .catch(() => {});
      }

      formatMoney(cents) {
        const amount = (Math.max(cents, 0) / 100).toFixed(2).replace('.', ',');
        return 'R$ ' + amount;
      }

      setWidth(percent) {
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => {
          if (this.barEl) this.barEl.style.width = percent + '%';
        });
      }

      update(total, cartItems = []) {
        if (!this.textEl || !this.barEl) return;

        const hasFreeShippingProduct = cartItems.some(item =>
          this.freeShippingProductIds.includes(item.product_id)
        );

        const freeShippingAchieved = hasFreeShippingProduct || total >= this.threshold;

        if (!this.threshold || this.threshold <= 0 || (total <= 0 && !hasFreeShippingProduct)) {
          this.classList.add('hidden');
          this.setWidth(0);
          return;
        }

        this.classList.remove('hidden');

        if (freeShippingAchieved) {
          this.textEl.innerHTML = 'Você <strong>ganhou frete grátis</strong>';
          this.setWidth(100);
          this.setAttribute('data-complete', 'true');
        } else {
          const remaining = this.threshold - total;

          this.textEl.innerHTML =
            'adicione <strong>' + this.formatMoney(remaining) + '</strong> e <strong>ganhe</strong> frete grátis';

          const percent = Math.min(100, Math.max(0, (total / this.threshold) * 100));
          this.setWidth(Number(percent.toFixed(2)));
          this.removeAttribute('data-complete');
        }
      }
    }
  );
}